import React, { Component } from 'react';
import { Text, View, Image, ScrollView, Dimensions, Platform } from 'react-native';
import { postSingle, Flex, Padding, Margin, Helpers, Typo, article, pageCover, FontFamily, popularStories, Colors, button } from '../../styles/appStyles';
import { helpers } from '../../utils/helpers';
import PageBreak from '../page-break';
import TouchableOpacityLink from '../touchable-opacity-link';
import getImagePath from '../../utils/image-helper';
import CustomImage from '../custom-image';
import Cookies from "universal-cookie";
import AuthenticationWrapper from '../authentication-wrapper';
import TouchableOpacityLinkExternal from '../touchable-opacity-link-external';
import ButtonGradient from '../button-gradient';

const Startup = getImagePath('img/startup-img.png');
const Fintech = getImagePath('img/fintech-img.png');
const Retail = getImagePath('img/retail-img.png');
const eccomerce = getImagePath('img/eccomerce-img.png');
const media = getImagePath('img/media-img.png');

//mobile
const StartupMobImg = getImagePath('img/m-startup-img.png');
const FintechMobImg = getImagePath('img/m-fintech-img.png');
const RetailMobImg = getImagePath('img/m-retail-img.png');
const eccomerceMobImg = getImagePath('img/m-ecomerce-img.png');
const mediaMobImg = getImagePath('img/m-media-img.png');


const cookies = new Cookies();

export class HomeNewsletterCategories extends Component {
    constructor(props) {
        super(props);
        let webView = helpers.isWeb();
        // const {isAuthenticated, fetchToken} = this.props.auth
        // let token = webView ? (process.browser ? (isAuthenticated?fetchToken:false) : this.props.token) : this.props.user?.userData?.data?.token;
        this.state = {
            showToken: (!helpers.isWeb() || process.browser) ? true : false,
        }
    }

    componentDidMount = () => {
    }

    trackThemeClick = (theme) => {
        if (this.props.trackThemeClick) {
            this.props.trackThemeClick(theme)
        }
    }

    render() {
        const { transparentBg, data, subscription, loggedOut, getTagClick, darkMode } = this.props;
        let internetProp, businessProp, govtProp, economicsProp, chaosProp, sportsProp, scienceProp, legalProp;
        let btnClickNewsletter, btnClickSignUp;
        let webView = helpers.isWeb();
        if (helpers.isWeb()) {
            btnClickSignUp = {
                href: "/sign-up"
            }
        } else {
            btnClickSignUp = {
                onPress: () => navigateApp('/sign-up')
            }
        }
        if (helpers.isWeb()) {
            btnClickNewsletter = {
                href: "/newsletters"
            }
        } else {
            btnClickNewsletter = {
                onPress: () => navigateApp('/newsletters')
            }
        }
        if (helpers.isWeb()) {
            internetProp = {
                to: "/tag/agriculture"
            };
            businessProp = {
                to: "/tag/sports"
            };
            govtProp = {
                to: "/tag/economy"
            };
            chaosProp = {
                to: "/tag/science"
            };
            economicsProp = {
                to: "/tag/environment"
            };
            
        } else {
            internetProp = {
                onPress: () => getTagClick('agriculture')
            };
            businessProp = {
                onPress: () => getTagClick('sports')
            };
            govtProp = {
                onPress: () => getTagClick('economy')
            };
            chaosProp = {
                onPress: () => getTagClick('science')
            };
            sportsProp = {
                onPress: () => getTagClick('environment')
            };            
        }
        return (
            <View style={[Margin.mb_3,helpers.isDesktop() && {alignSelf:'center'}, !helpers.isDesktop() && { alignItems: 'center' }, { backgroundColor: transparentBg ? 'transparent' : darkMode ? Colors.darkBlackColorBg : '#FFF' }]}>
                <View style={[helpers.isDesktop() && {
                    marginLeft: 'auto',
                    marginRight: 'auto',
                },
                Padding.pt_3
                ]}>
                    {!subscription && <View style={[Flex.alignCenter]}>
                        <View style={[Helpers.titleBgWrap, { backgroundColor: 'transparent' }]}>
                            <Text style={[Helpers.textCenter, Typo.h3_R, helpers.isDesktop() && Typo.h3_RDesktop, Margin.mb_0, { fontFamily: FontFamily.abrilFatface }, { fontSize: helpers.isDesktop() ? 34 : 30, }, {color: darkMode ? 'rgba(255,255,255,0.87)': helpers.isDesktop() ? "000" : "#051462" }]}>{data.title}</Text>
                        </View>
                    </View>}
                </View>
                <View style={[helpers.isDesktop() && Padding.ph_2, Helpers.conatinerWeb, { flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center',}, helpers.isDesktop() && Helpers.conatinerWebFull, helpers.isDesktop() && Margin.mt_2, !helpers.isDesktop() &&  {justifyContent:'center'}]}>
                    {subscription &&
                        <View style={[{ borderWidth: 1, borderColor: '#7B8FFE', borderRadius: 30, backgroundColor: '#fff' }, helpers.isDesktop() && { margin: 10 }]}>
                            <View style={[Flex.alignCenter, helpers.isDesktop() && Margin.mb_7, !helpers.isDesktop() && Margin.mb_4, { width: helpers.isWeb() ? 'fit-content' : '100%', marginLeft: 'auto', marginRight: 'auto' }]}>
                                <View style={[Padding.ph_2, Helpers.titleBgWrap, { backgroundColor: 'transparent' }]}>
                                    <Text style={[Helpers.textCenter, Typo.h3_R, helpers.isDesktop() && Typo.h3_RDesktop, Margin.mb_0, { fontFamily: FontFamily.abrilFatface }, { fontSize: helpers.isDesktop() ? 24 : 18, color: '#7B8FFE' }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { paddingHorizontal: 10, paddingVertical: 0 }]}>{data.title}</Text>
                                </View>
                            </View>
                        </View>
                    }
                    <View style={[!helpers.isDesktop() && { padding: 10 }, helpers.isDesktop() && { margin: 10 }]}>
                        <TouchableOpacityLink {...internetProp} handleClick={() => this.trackThemeClick('internet')}>
                            <View style={[{ borderWidth: 1, borderColor: '#7B8FFE', borderRadius: 30, backgroundColor: '#fff' }, !helpers.isDesktop() && { paddingBottom: 0, marginLeft: 0, marginRight: 0 }, !process.browser && { width: 300 }, !helpers.isWeb() && { width: '100%' }, darkMode && { backgroundColor: '#1E1E1E' }]}>
                                <View style={[Flex.row, Flex.alignCenter, Flex.justifyBetween, { alignItems: 'baseline' }, !webView && { alignItems: 'center' }]}>
                                    <Text style={[popularStories.imageTitle, helpers.isDesktop() && popularStories.imageTitleDesktop, { color: '#7B8FFE' }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { paddingHorizontal: 20, paddingVertical: 0 }]}>Agriculture</Text>
                                </View>
                            </View>
                        </TouchableOpacityLink>
                    </View>
                    <View style={[!helpers.isDesktop() && { padding: 10 }, helpers.isDesktop() && { margin: 10 }]}>
                        <TouchableOpacityLink {...businessProp} handleClick={() => this.trackThemeClick('business')}>
                            <View style={[{ borderWidth: 1, borderColor: '#7B8FFE', borderRadius: 30, backgroundColor: '#fff' }, !helpers.isDesktop() && { paddingBottom: 0, marginLeft: 0, marginRight: 0 }, !process.browser && { width: 300 }, !helpers.isWeb() && { width: '100%' }, darkMode && { backgroundColor: '#1E1E1E' }]}>
                                <View style={[Flex.row, Flex.alignCenter, Flex.justifyBetween, { alignItems: 'baseline' }, !webView && { alignItems: 'center' }]}>
                                    <Text style={[popularStories.imageTitle, helpers.isDesktop() && popularStories.imageTitleDesktop, { color: '#7B8FFE' }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { paddingHorizontal: 20, paddingVertical: 0 }]}>Sports</Text>
                                </View>
                            </View>
                        </TouchableOpacityLink>
                    </View>
                    <View style={[!helpers.isDesktop() && { padding: 10 }, helpers.isDesktop() && { margin: 10 }]}>
                        <TouchableOpacityLink {...chaosProp} handleClick={() => this.trackThemeClick('chaos')}>
                            <View style={[{ borderWidth: 1, borderColor: '#7B8FFE', borderRadius: 30, backgroundColor: '#fff' }, !helpers.isDesktop() && { paddingBottom: 0, marginLeft: 0, marginRight: 0 }, !process.browser && { width: 300 }, !helpers.isWeb() && { width: '100%' }, darkMode && { backgroundColor: '#1E1E1E' }]}>
                                <View style={[Flex.row, Flex.alignCenter, Flex.justifyBetween, { alignItems: 'baseline' }, !webView && { alignItems: 'center' }]}>
                                    <Text style={[popularStories.imageTitle, helpers.isDesktop() && popularStories.imageTitleDesktop, { color: '#7B8FFE' }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { paddingHorizontal: 20, paddingVertical: 0 }]}>Economy</Text>
                                </View>
                            </View>
                        </TouchableOpacityLink>
                    </View>
                    <View style={[!helpers.isDesktop() && { padding: 10 }, helpers.isDesktop() && { margin: 10 }]}>
                        <TouchableOpacityLink {...sportsProp} handleClick={() => this.trackThemeClick('sports')}>
                            <View style={[{ borderWidth: 1, borderColor: '#7B8FFE', borderRadius: 30, backgroundColor: '#fff' }, !helpers.isDesktop() && { paddingBottom: 0, marginLeft: 0, marginRight: 0 }, !process.browser && { width: 300 }, !helpers.isWeb() && { width: '100%' }, darkMode && { backgroundColor: '#1E1E1E' }]}>
                                <View style={[Flex.row, Flex.alignCenter, Flex.justifyBetween, { alignItems: 'baseline' }, !webView && { alignItems: 'center' }]}>
                                    <Text style={[popularStories.imageTitle, helpers.isDesktop() && popularStories.imageTitleDesktop, { color: '#7B8FFE' }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { paddingHorizontal: 20, paddingVertical: 0 }]}>Science</Text>
                                </View>
                            </View>
                        </TouchableOpacityLink>
                    </View>
                    <View style={[!helpers.isDesktop() && { padding: 10 }, helpers.isDesktop() && { margin: 10 }]}>
                        <TouchableOpacityLink {...economicsProp} handleClick={() => this.trackThemeClick('economics')}>
                            <View style={[{ borderWidth: 1, borderColor: '#7B8FFE', borderRadius: 30, backgroundColor: '#fff' }, !helpers.isDesktop() && { paddingBottom: 0, marginBottom: 0, marginLeft: 0, marginRight: 0 }, !process.browser && { width: 300 }, !helpers.isWeb() && { width: '100%' }, darkMode && { backgroundColor: '#1E1E1E' }]}>
                                <View style={[Flex.row, Flex.alignCenter, Flex.justifyBetween, { alignItems: 'baseline' }, !webView && { alignItems: 'center' }]}>
                                    <Text style={[popularStories.imageTitle, helpers.isDesktop() && popularStories.imageTitleDesktop, { color: '#7B8FFE' }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { paddingHorizontal: 20, paddingVertical: 0 }]}>Environment</Text>
                                </View>
                            </View>
                        </TouchableOpacityLink>
                    </View>
                </View>
                {loggedOut ?
                    <View style={[helpers.isDesktop() && Flex.row, Margin.mh_5], { alignSelf: 'center', marginTop: 20 }}>
                        <TouchableOpacityLinkExternal {...btnClickSignUp} newTab={true}>
                            <ButtonGradient
                                title={'SIGN UP TO SUBSCRIBE'}
                                rootStyle={{
                                    btnWrapper: [button.primaryGradient, { height: 50 }],
                                    btnText: [button.primaryGradientText, { fontSize: 16, paddingHorizontal: 45, fontWeight: '600', fontFamily: FontFamily.regular }]
                                }}
                                paddingOverride={true}
                                onClick={() => { }}
                                darkMode={darkMode}
                            />
                        </TouchableOpacityLinkExternal>
                    </View>
                    :
                    <View style={[helpers.isDesktop() && Flex.row, Margin.mh_3], { alignSelf: 'center', marginTop: 20 }}>
                        <TouchableOpacityLinkExternal {...btnClickNewsletter} newTab={true}>
                            <ButtonGradient
                                title={'VIEW ALL NEWSLETTERS'}
                                rootStyle={{
                                    btnWrapper: [button.primaryGradient, { height: 55 }],
                                    btnText: [button.primaryGradientText, { fontSize: 17, paddingHorizontal: 35, fontWeight: '600', fontFamily: FontFamily.regular }]
                                }}
                                paddingOverride={true}
                                onClick={() => { }}
                                darkMode={darkMode}
                            />
                        </TouchableOpacityLinkExternal>
                    </View>
                }
            </View >
        );
    }
}

export default AuthenticationWrapper(HomeNewsletterCategories);
